import useSWR from "swr";

import { simpleFetcher } from "../fetcher";

interface DiffSummary {
  createdAt: string;
  updatedAt: string;
  summary: string;
}

export const useDiffSummary = (documentVersionId: number | undefined) => {
  return useSWR<DiffSummary, Error>(
    documentVersionId
      ? `/api/v2/document-versions/${documentVersionId}/diff-summary`
      : null,
    simpleFetcher,
  );
};
